import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Alert } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppSelector } from '../../../../hooks.js';
import { errorStatusSelector } from '../../passwordlessSlice.js';
export const ResendEmailErrorAlert = () => {
    const { t } = useTranslation();
    const errorStatus = useAppSelector(errorStatusSelector);
    const errorMessage = t('loginregistration.passwordless.resendEmail.error');
    return errorStatus ? (_jsx(Alert, { variant: 'negative', mb: 'spaceL', isDismissible: false, children: errorMessage })) : null;
};
//# sourceMappingURL=ResendEmailErrorAlert.js.map